import DisplayOptions from '../../../../components/LoginAndForgotPasswordCard/types/DisplayOptions';
import UIParameters from '../../../../types/UIParameters';

export default function loginFormDisplayFromUIParameters(
    uiParameters: UIParameters | undefined
): DisplayOptions {
    if (!uiParameters) {
        return 'hidden';
    }

    if (uiParameters.forceLogin) {
        return 'force';
    }

    if (uiParameters.showLoginForm) {
        return 'optional';
    }

    return 'hidden';
}
